import { createSlice } from '@reduxjs/toolkit'
import type { PayloadAction } from '@reduxjs/toolkit'
import { PersistConfig } from 'redux-persist'
import { storage } from '../core'
import { ExchangeRateMap } from './lookup.api.types'

export interface LookupState {
  exchangeRates: ExchangeRateMap
  exchangeRatesLastFetchedAt: string | null
}

const initialState: LookupState = {
  exchangeRates: {},
  exchangeRatesLastFetchedAt: null,
}

export const LOOKUP_STATE_NAME = 'lookup'

export const lookupSlice = createSlice({
  name: LOOKUP_STATE_NAME,
  initialState,
  reducers: {
    setExchangeRates: (
      state,
      action: PayloadAction<{ rates: ExchangeRateMap; lastFetchedAt: string }>,
    ) => {
      state.exchangeRates = action.payload.rates
      state.exchangeRatesLastFetchedAt = action.payload.lastFetchedAt
    },
  },
})

export const lookupSliceConfig: PersistConfig<LookupState> = {
  storage,
  key: LOOKUP_STATE_NAME,
  whitelist: ['exchangeRates', 'exchangeRatesLastFetchedAt'],
}

export const { setExchangeRates } = lookupSlice.actions
export const lookupReducer = lookupSlice.reducer
export default lookupSlice.reducer
